export const capitalizeWords = (str) => {
  if (!str) return "";
  return str
    .replace(/[-\s]+(.)/g, (match, char) => " " + char.toUpperCase())
    .replace(/^\w/, (char) => char.toUpperCase());
};
